import { useMemo } from 'react';

import { createStateSelectorHook } from 'src/lib/sweetState';
import { MultiPromptTemplatesStore } from 'src/store';

const useMultiPromptTemplatesState = createStateSelectorHook(MultiPromptTemplatesStore, [
  'multiPromptTemplates',
]);

export const useMultiPromptTemplate = (customTemplateId) => {
  const { multiPromptTemplates } = useMultiPromptTemplatesState();

  return useMemo(() => {
    if (!customTemplateId) {
      return null;
    }

    return multiPromptTemplates.find((t) => t.id === customTemplateId);
  }, [customTemplateId, multiPromptTemplates]);
};
